import { Link } from "react-router-dom";
import { FadeIn } from "@/components/Reveal";

const Footer = () => (
  <footer data-testid="site-footer" className="relative overflow-hidden border-t border-white/10">
    <div className="mx-auto max-w-[1600px] px-6 pt-20 md:px-12">
      <FadeIn>
        <p className="text-center font-body text-[11px] uppercase tracking-[0.45em] text-ember">
          Tools Built From Real Jobsite Problems
        </p>
        <h2
          className="mt-6 select-none text-center font-display text-[clamp(3.4rem,12.5vw,13rem)] font-semibold uppercase leading-[0.85] tracking-tight text-stroke-silver"
          aria-hidden="true"
        >
          Proxima Centauri
        </h2>
      </FadeIn>

      <div className="mt-16 flex flex-col items-center justify-between gap-8 border-t border-white/10 py-10 md:flex-row">
        <div className="flex items-center gap-4">
          <img src="/logo.png" alt="Proxima Centauri Tools logo" className="h-10 w-10 object-cover" />
          <span className="font-body text-xs text-ash">© 2026 Proxima Centauri Tools. All rights reserved.</span>
        </div>
        <nav className="flex items-center gap-8" aria-label="Footer">
          {[
            { id: "home", label: "Home" },
            { id: "tools", label: "Our Tools" },
            { id: "about", label: "About" },
            { id: "contact", label: "Contact" },
          ].map((link) => (
            <Link
              key={link.id}
              data-testid={`footer-link-${link.id}`}
              to={`/#${link.id}`}
              className="font-display text-base uppercase tracking-[0.2em] text-ash transition-colors duration-300 hover:text-ember"
            >
              {link.label}
            </Link>
          ))}
        </nav>
      </div>
    </div>
  </footer>
);

export default Footer;
